import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import * as _ from 'lodash-es';
import { TranslationEntry } from '@app/shared/models/translatable';

export enum CaseFileCategories {
    MAIN_DOCUMENT = 'MAIN_DOCUMENT',
    REPAIR_COST_ASSUMPTION = 'REPAIR_COST_ASSUMPTION',
    DECLARATION_OF_ASSIGNMENT = 'DECLARATION_OF_ASSIGNMENT',
    PRELIMINARY_CALCULATION = 'PRELIMINARY_CALCULATION',
    FOREIGN_INVOICE = 'FOREIGN_INVOICE',
    DATA_PROTECTION = 'DATA_PROTECTION',
    CLAIM_IMAGE = 'CLAIM_IMAGE',
    ACCIDENT_DOCUMENT = 'ACCIDENT_DOCUMENT',
    CORRESPONDENCE = 'CORRESPONDENCE',
    ADDITIONAL_DOCUMENT = 'ADDITIONAL_DOCUMENT'
}

export class CaseFileCategory {

    private static readonly all: TranslationEntry[] = [
        { key: CaseFileCategories.MAIN_DOCUMENT, trans: marker('contentstore.case.categories.MAIN_DOCUMENT')} ,
        { key: CaseFileCategories.REPAIR_COST_ASSUMPTION, trans: marker('contentstore.case.categories.REPAIR_COST_ASSUMPTION')} ,
        { key: CaseFileCategories.DECLARATION_OF_ASSIGNMENT, trans: marker('contentstore.case.categories.DECLARATION_OF_ASSIGNMENT')} ,
        { key: CaseFileCategories.PRELIMINARY_CALCULATION, trans: marker('contentstore.case.categories.PRELIMINARY_CALCULATION')} ,
        { key: CaseFileCategories.FOREIGN_INVOICE, trans: marker('contentstore.case.categories.FOREIGN_INVOICE')} ,
        { key: CaseFileCategories.DATA_PROTECTION, trans: marker('contentstore.case.categories.DATA_PROTECTION')} ,
        { key: CaseFileCategories.CLAIM_IMAGE, trans: marker('contentstore.case.categories.CLAIM_IMAGE')} ,
        { key: CaseFileCategories.ACCIDENT_DOCUMENT, trans: marker('contentstore.case.categories.ACCIDENT_DOCUMENT')},
        { key: CaseFileCategories.CORRESPONDENCE, trans: marker('contentstore.case.categories.CORRESPONDENCE')} ,
        { key: CaseFileCategories.ADDITIONAL_DOCUMENT, trans: marker('contentstore.case.categories.ADDITIONAL_DOCUMENT')}
    ];

    public static getByKey(key: string): TranslationEntry {
        return _.find(CaseFileCategory.all, (type: TranslationEntry) => type.key === key);
    }

    public static get ALL() {
        return CaseFileCategory.all;
    }

    public static get MAIN_DOCUMENT() {
        return CaseFileCategory.getByKey('MAIN_DOCUMENT');
    }

    public static get REPAIR_COST_ASSUMPTION() {
        return CaseFileCategory.getByKey('REPAIR_COST_ASSUMPTION');
    }

    public static get DECLARATION_OF_ASSIGNMENT() {
        return CaseFileCategory.getByKey('DECLARATION_OF_ASSIGNMENT');
    }

    public static get PRELIMINARY_CALCULATION() {
        return CaseFileCategory.getByKey('PRELIMINARY_CALCULATION');
    }

    public static get FOREIGN_INVOICE() {
        return CaseFileCategory.getByKey('FOREIGN_INVOICE');
    }

    public static get DATA_PROTECTION() {
        return CaseFileCategory.getByKey('DATA_PROTECTION');
    }

    public static get CLAIM_IMAGE() {
        return CaseFileCategory.getByKey('CLAIM_IMAGE');
    }

    public static get ACCIDENT_DOCUMENT() {
        return CaseFileCategory.getByKey('ACCIDENT_DOCUMENT');
    }

    public static get CORRESPONDENCE() {
        return CaseFileCategory.getByKey('CORRESPONDENCE');
    }

    public static get ADDITIONAL_DOCUMENT() {
        return CaseFileCategory.getByKey('ADDITIONAL_DOCUMENT');
    }
}
